<template>
  <div class="title">
    <slot/>
  </div>
</template>
<script>
  export default {
    name: "CommonTitle"
  };
</script>
<style lang="scss" scope>
  .title {
    font-family: PingFang SC;
    font-size: 40px;
    font-weight: 700;
    font-stretch: normal;
    line-height: 56px;
    letter-spacing: 1px;
    color: #333;
  }
</style>
